<div class="main-container" *ngIf="htmlString">
    <div class="confirmation-container">
        <div [innerHTML]="htmlString" >
        </div>
    </div>
</div>